import Icon from '../components/Icon.vue'

Icon.register({"male":{"width":192,"height":512,"paths":[{"d":"M96 0C131.3 0 160 28.7 160 64S131.3 128 96 128 32 99.3 32 64 60.7 0 96 0M144 144H132.6C109.9 154.4 83 154.9 59.4 144H48C21.5 144 0 165.5 0 192V328C0 341.3 10.7 352 24 352H40V488C40 501.3 50.7 512 64 512H128C141.3 512 152 501.3 152 488V352H168C181.3 352 192 341.3 192 328V192C192 165.5 170.5 144 144 144z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/male.js
// module id = slI1
// module chunks = 0